// Search result skeletons — visual feedback while results are being fetched.
//
// Mirrors the real row structure (media left, breadcrumb/title/excerpt right) so
// the layout does not jump when the real rows swap in.

var LINE_WIDTHS = ['100%', '96%', '72%'];

function itemHtml() {
  var lines = '';
  for (var i = 0; i < LINE_WIDTHS.length; i++) {
    lines += '<span class="mad-search-list__skeleton mad-search-list__skeleton--line" style="width:' + LINE_WIDTHS[i] + '"></span>';
  }

  return '<li class="mad-search-list__item mad-search-list__item--skeleton" aria-hidden="true">' +
    '<div class="mad-search-list__media mad-search-list__skeleton"></div>' +
    '<div class="mad-search-list__body">' +
      '<span class="mad-search-list__skeleton mad-search-list__skeleton--breadcrumb"></span>' +
      '<span class="mad-search-list__skeleton mad-search-list__skeleton--title"></span>' +
      lines +
    '</div>' +
  '</li>';
}

// Rows only — for appending below existing results (load more).
function itemsHtml(count) {
  var html = '';
  for (var i = 0; i < count; i++) {
    html += itemHtml();
  }
  return html;
}

// A full replacement list — for a fresh search.
function listHtml(count) {
  return '<ul class="mad-search-list__items mad-search-list__items--skeleton" role="presentation">' +
    itemsHtml(count) +
  '</ul>';
}

// AI-overview body skeleton — mirrors ai-overview/template-default.php.
function aiBodyHtml() {
  return '<div class="mad-search-ai__skeleton"></div>' +
    '<div class="mad-search-ai__skeleton"></div>' +
    '<div class="mad-search-ai__skeleton mad-search-ai__skeleton--short"></div>';
}

module.exports = {
  itemsHtml: itemsHtml,
  listHtml: listHtml,
  aiBodyHtml: aiBodyHtml
};
